'use client';

import { useRouter, useSearchParams } from 'next/navigation';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';

import { AuthFormType } from './Authform.type';
import ForgotPasswordForm from './ForgotPasswordForm';
import LoginForm from './LoginForm';
import RegisterForm from './RegisterForm';

interface AuthFormProps {
  onSuccessCallback: () => void;
  defaultForm?: AuthFormType;
  allowGuestAccount?: boolean;
  formAdditionalContent?: {
    register?: React.ReactNode;
    login?: React.ReactNode;
    forgotPassword?: React.ReactNode;
  };
}

export default function AuthForm({
  onSuccessCallback,
  defaultForm = 'register',
  formAdditionalContent,
  allowGuestAccount = false,
}: AuthFormProps) {
  const [selectedForm, setSelectedForm] = useState<AuthFormType>(defaultForm);
  const searchParams = useSearchParams();
  const router = useRouter();

  const error = searchParams.get('error');

  useEffect(() => {
    if (!!error) {
      try {
        toast.error(error, { duration: 5000 });
      } catch (err) {}

      const params = new URLSearchParams(window.location.search);
      params.delete('error');

      const newUrl = `${window.location.pathname}?${params.toString()}`;
      router.replace(newUrl, undefined);
    }
  }, [searchParams, error]);

  return (
    <div>
      {selectedForm === 'register' && (
        <RegisterForm
          onSuccessCallback={onSuccessCallback}
          setSelectedForm={setSelectedForm}
          aditionalContent={formAdditionalContent?.register}
          allowGuestAccount={allowGuestAccount}
        />
      )}
      {selectedForm === 'login' && (
        <LoginForm
          onSuccessCallback={onSuccessCallback}
          setSelectedForm={setSelectedForm}
          aditionalContent={formAdditionalContent?.login}
        />
      )}
      {selectedForm === 'forgot-password' && (
        <ForgotPasswordForm
          onSuccessCallback={onSuccessCallback}
          setSelectedForm={setSelectedForm}
          aditionalContent={formAdditionalContent?.login}
        />
      )}
    </div>
  );
}
